import React, { useEffect, useState } from "react";
import PageWrapper from "../../components/Page/PageWrapper";
import PageHeader from "../../components/Header/PageHeader";
import TextArea from "../../components/Input/TextArea";
import TextInput from "../../components/Input/TextInput";
import { Grid } from "@material-ui/core";
import Checkbox from "../../components/Input/Checkbox";
import { useHistory } from "react-router-dom";
import { ProjectActions } from "../../reducers/project/actionsNames";
import { useDispatch, useSelector } from "react-redux";
import { getCartId, getForm } from "../../reducers/project/selectors";
import content from "../../content";
import useDesktop  from "../../components/Responsive/useDesktop";
import Components  from "../Drawers/Components";
import { InfoBar } from "../../components/Dialogs/InfoBar";
import styled from "styled-components";
import { RadioInput } from "../../components/Input/RadioInput";
import { RadioElement } from "../../components/Input/RadioElement";
import { Button } from "./Creator";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 32px;

  width: 100%;
  height: calc(100% - 98px);
  margin-top: 16px;
  min-width: 0;
  box-sizing: border-box;

  background: #ffffff;
  border-radius: 4px;
`;

function OrderForm({}: IForm) {
  const cart = useSelector(getCartId);
  const history = useHistory();
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    notes: "",
    agree: false,
    fastOrder: false,
  });

  const [error, setError] = useState<any>({
    name: null,
    phone: null,
    email: null,
    notes: null,
    agree: null,
    fastOrder: null,
  });

  const dispatch = useDispatch();
  const formState = useSelector(getForm);

  const change = (input: string, checkbox = false) => (e) => {
    if (checkbox) {
      setForm({ ...form, [input]: e.target.checked });
    } else {
      setForm({ ...form, [input]: e.currentTarget.value });
    }
    setError({ ...error, [input]: null });
  };

  const validate = () => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const rp = /^([0-9]{9})$/;
    let errors = {};
    if (!form.name) {
      errors["name"] = content.getValue("form_error_name");
    }
    if (!form.email || !re.test(String(form.email).toLowerCase())) {
      errors["email"] = content.getValue("form_error_email");
    }
    if (!form.phone || !rp.test(String(form.phone))) {
      errors["phone"] = content.getValue("form_error_phone");
    }
    if (!form.agree) {
      errors["agree"] = content.getValue("form_error_agree");
    }
    setError({ ...error, ...errors });

    if (Object.values(errors).every((e) => !Boolean(e))) {
      dispatch({ type: ProjectActions.SetForm, form });
      dispatch({ type: ProjectActions.CreateOrder });
      history.push("/confirmation");
    }
  };

  const required = ["name", "phone", "email", "agree"];

  const desktop = useDesktop();

  useEffect(() => {
    if (!cart) {
      history.push("/");
    }
  }, [cart]);

  return (
      <div style={{ width: "100%", height: "100%" }}>
        <PageHeader
            color={"#F9F9F9"}
            height={"auto"}
            header={content.getValue("offer_request")}
        />
        <PageWrapper row={desktop}>
          <div
              style={{
                width: desktop ? "75%" : "100%",
                padding: desktop ? "0px 32px 24px" : "0px 24px 24px 24px",
                paddingRight: desktop ? "0" : "24px",
                boxSizing: "border-box",
              }}
          >
            {/*<InfoBar infoContent={content.getValue("info_content")} />*/}
            <Wrapper style={{ marginRight: desktop ? "150px" : "unset" }}>
              <Grid container={true} spacing={desktop ? 5 : 0}>
                <Grid sm={4} item={true} xs={12}>
                  <TextInput
                      error={error["name"]}
                      value={form["name"]}
                      onChange={change("name")}
                      name={"name"}
                      placeholder={"Wpisz swoje imię i nazwisko"}
                      inputLabel={content.getValue("form_name")}
                  />
                </Grid>
                <Grid sm={2} xs={12} item={true}>
                  <TextInput
                      error={error["phone"]}
                      value={form["phone"]}
                      onChange={change("phone")}
                      placeholder={"Wpisz swój numer telefonu"}
                      name={"phone"}
                      inputLabel={content.getValue("form_phone")}
                  />
                </Grid>
              </Grid>
              <Grid
                  key={JSON.stringify(error)}
                  container={true}
                  spacing={desktop ? 5 : 0}
              >
                <Grid sm={4} xs={12} item={true}>
                  <TextInput
                      error={error["email"]}
                      value={form["email"]}
                      placeholder={"Wpisz swój adres email"}
                      onChange={change("email")}
                      name={"email"}
                      inputLabel={content.getValue("form_email")}
                  />
                </Grid>
                <Grid sm={4} xs={12} item={true}>
                  <RadioInput
                      value={form["fastMethod"]}
                      onChange={change("fastMethod")}
                      name={"fastMethod"}
                      inputLabel={content.getValue("fast_order")}
                  >
                    <RadioElement name={"email"} label={"Email"} />
                    <RadioElement name={"phone"} label={"Telefon"} />
                    <RadioElement name={"sms"} label={"SMS"} />
                  </RadioInput>
                </Grid>
              </Grid>
              <TextArea
                  rows={6}
                  name={"notes"}
                  value={form["notes"]}
                  placeholder={"Wpisz tekst"}
                  onChange={change("notes")}
                  style={{ width: desktop ? "70%" : "100%" }}
                  inputLabel={content.getValue("form_notes")}
              />
              {/*<Checkbox*/}
              {/*    error={error["fastOrder"]}*/}
              {/*    value={form["fastOrder"]}*/}
              {/*    checked={form["fastOrder"]}*/}
              {/*    onChange={change("fastOrder", true)}*/}
              {/*    name={"check1"}*/}
              {/*    inputLabel={content.getValue("form_fast_order_label")}*/}
              {/*    label={content.getValue("form_fast_order_checkbox")}*/}
              {/*/>*/}
              <Checkbox
                  error={error["agree"]}
                  value={form["agree"]}
                  checked={form["agree"]}
                  onChange={change("agree", true)}
                  name={"check2"}
                  inputLabel={content.getValue("form_agreement_label")}
                  label={content.getValue("form_agreement_checkbox")}
              />
            </Wrapper>
          </div>
          {desktop && <Components to={"confirmation"} validate={validate} />}
          {!desktop && (
              <div>
                <Button
                    onClick={validate}
                    label={content.getValue("go_next")}
                ></Button>
              </div>
          )}
        </PageWrapper>
      </div>
  );
}

export interface IForm {}

export default OrderForm;
